<div class="modal-auth" *ngIf="isOpen">
  <div class="modal-auth-content" [ngClass]="{ 'open-two': isOpenTwo }">
    <ng-content select=".primary-modal"></ng-content>
  </div>
  <div class="modal-auth-content-two" *ngIf="isOpenTwo">
    <ng-content select=".second-modal"></ng-content>
  </div>
</div>
